import React, { Component, useEffect, useState } from 'react'
import { useFormInput } from '../utils';
import { loadLanguage, saveLanguage } from '../utils/Network';
import { useHistory } from 'react-router';



export default function LanguageContent({ id }) {


    const history = useHistory();

    const [name, setName] = useState("");
    const [abbreviation, setAbbreviation] = useState("");
    const [is_default, setIsDefault] = useState(false);


    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    useEffect(() => {

        if (id) {
            loadLanguage(id).then(language => {
                setName(language.name)
                setAbbreviation(language.abbreviation)
                setIsDefault(language.is_default)
            });
        }
    }, [])

    const onChange = (e) => {

        //alert(e.target.name)
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break;
            case 'abbreviation':
                setAbbreviation(e.target.value)
                break;
            case 'is_default':
                setIsDefault(e.target.checked)
                break;
            default:

                break;
        }


    }
    const saveChanges = () => {


        setError(null);
        setLoading(true);

        if (name.length < 3) {
            setError('Please Enter Name');
            setLoading(false);
            return;
        }
        if (abbreviation.length < 1) {
            setError('Please Enter Abbreviation');
            setLoading(false);
            return;
        }

        if (!error)
            saveLanguage({ id: id, name: name, abbreviation: abbreviation, is_default: is_default })
                .then(function (data) {
                    history.go('/languages?success=true');
                });



    }
    const toggleCheckboxChange = (e) => {
        setIsDefault(e.target.checked);
    }

    return (
        <>


            <div className="col-md-6">
                <div class="box box-primary  bg-ddd">
                    <div class="box-header with-border">
                        <h3 class="box-title">Add New </h3>
                    </div>
                    <div className="box-body padding-10 overflow-hidden">
                        <form className="form-horizontal">
                            <div >
                                <div className="form-group row">
                                    <div className="col-sm-6 mb-5">
                                        <input type="text" value={abbreviation} name="abbreviation" onChange={onChange} className="form-control" placeholder="Abbrivation" />
                                    </div>
                                    <div className="col-sm-6 mb-5">
                                        <input type="text" value={name} name="name" onChange={onChange} className="form-control" placeholder="Name" />
                                    </div>
                                </div>
                                
                                
                                <div className="form-group row">
                                    
                                        <div className="col-sm-4">
                                            <input type="checkbox" onChange={toggleCheckboxChange} checked={is_default} className="form-check-input mr-1" />
                                             Default
                                        </div>
                                        <label className="form-check-label" for="exampleCheck2"></label>

                                   
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="box-footer ">
                        {id && (<>
                            <a href="/cms/languages" class="btn btn-default">Cancel</a>
                        </>)}

                        <button type="button" onClick={saveChanges} disabled={loading} class="btn btn-primary pull-right">Save Changes</button>
                    </div>
                </div>
                {error && (
                    <>

                        <div className="alert alert-danger">
                            {error}
                        </div>
                    </>
                )}

                {loading && (
                    <>
                        <div className="alert alert-info">
                            please wait...
                        </div>
                    </>
                )}
            </div>


        </>


    )

}
